import React, { useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components';
import { createBlockNote } from '@workturbo/blocknote';
import '@workturbo/blocknote/dist/blocknote.css';
import Title from './title';

const Wrapper = styled.div`
  width: 100%;
  background: #fff;
  margin-top: 60px;
`;

const ContentContainer = styled.div`
  margin: 0 auto;
  max-width: 900px;
  &.full-width {
    max-width: 100%;
    margin: 0;
  }
`;

const Content = styled.div`
  width: 100%;
`;

const PageContent = ({ knowledge = {} }) => {
  const { pageSettings = {} } = knowledge;
  const editor = useMemo(
    () =>
      createBlockNote({
        isEditable: false,
        disableComments: true,
        hidePrivateBlocks: true,
        documentId: knowledge._id,
        initialUpdate: knowledge.contentBuffer
          ? Uint8Array.from(atob(knowledge.contentBuffer), (c) => c.charCodeAt(0))
          : undefined
      }),
    [knowledge]
  );

  const ref = useRef();
  useEffect(() => editor.mount(ref.current), [editor]);

  return (
    <Wrapper>
      <ContentContainer className={pageSettings?.fullWidth ? 'full-width' : ''}>
        <Title title={knowledge.name} />
        <Content ref={ref} />
      </ContentContainer>
    </Wrapper>
  );
};

export default PageContent;
